import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import withRouter from "components/Common/withRouter";

//i18n
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";

import { Link } from "react-router-dom";

import logo from "../../assets/images/ci_logo.png";
import logoDark from "../../assets/images/logo-dark.png";
import logoSymbol from "../../assets/images/subros_logo.svg"

const Sidebar = props => {

  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box">
          <Link to={`/dashboard`} className="logo logo-dark">
            <span className="logo-sm">
              <img src={logo} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src={logoDark} alt="" height="17" />
            </span>
          </Link>

          <Link  className="logo logo-light">
            <span className="logo-sm">
              <img src={logoSymbol} alt="" height="40" style={{borderBottom:"1px solid white",paddingBottom:"5px"}} />
            </span>
            {/* <hr/> */}
            <span className="logo-lg">
              <img src={logoSymbol} alt="" height="40" style={{borderBottom:"1px solid white",paddingBottom:"5px"}} />
              {/* <img src="https://payearly.cashinvoice.in/assets/images/CashInvoiceLogo.png" alt="" height="40" /> */}
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {<SidebarContent />}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  type: PropTypes.string,
};

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  };
};
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)));
